import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Spacer } from '@cleartrip/bento'
import TopDestinations from 'components/TopDestinations'
import TopDestinationsLoading from 'components/TopDestinations/Loading'
import { TripSuggestorApi } from 'api/flights/results'
import { API_STATES } from 'constants/stateMaps'

function TripSuggestor() {
    useEffect(() => {
        getTripSuggestorDetails()
    }, [])
    const [homeHotelList, setHomeHotelList] = useState({})
    const [apiState, setApiState] = useState()

    const getTripSuggestorDetails = async () => {
        try {
            setApiState(API_STATES.PENDING)
            const tripSuggestorApiResonse = await TripSuggestorApi('popular_destinations')

            const { status: tripSuggestorApiResonseStatus, data: tripSuggestorApiResonseData } =
                tripSuggestorApiResonse || {}
            if (tripSuggestorApiResonseStatus === 200) {
                if (tripSuggestorApiResonseData) {
                    setApiState(API_STATES.SUCCESS)
                    tripSuggestorApiResonseData.popular_destinations.destinations.pop()
                    // console.log(tripSuggestorApiResonseData)
                    setHomeHotelList(tripSuggestorApiResonseData)
                }
            }
        } catch (e) {
            console.log(e)
            setApiState(API_STATES.FAILURE)
        }
    }
    return (
        <div className="p-relative px-2 w-100p pt-12">
            <Row>
                <Col>
                    <h2 className="fs-7 fw-600 c-neutral-800">Popular destinations</h2>
                </Col>
            </Row>
            <Spacer className="pt-5" />
            <div className="o-scroll hide-scrollbar">
                {apiState === API_STATES.PENDING && <TopDestinationsLoading />}
                {apiState === API_STATES.SUCCESS && (
                    <TopDestinations resultsData={homeHotelList.popular_destinations} />
                )}
            </div>
        </div>
    )
}

export default TripSuggestor
